import React from 'react';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
import CustomRadio from '../../common/ui/CustomRadio';
import CardForMapping from './CardForMapping';

const ExportResponseFile = ({
  exportResponse,
  generateCSV,
  exportItemsPath,
  exportFileName,
  handleRadioChange,
  handleAuthData,
}) => {
  if (!exportResponse) {
    return '';
  }
  return (
    <CardForMapping color="drapcode-violet" title="Export Response to a File">
      <div className="row">
        <div className="col-4">
          <div className="form-check">
            <CustomRadio label="Download File Bytes" isRadio={true}>
              <input
                name="generateCSV"
                type="radio"
                className="form-check-input"
                checked={generateCSV === 'DOWNLOAD_FILE_BYTES'}
                value="DOWNLOAD_FILE_BYTES"
                onChange={handleRadioChange}
              />
            </CustomRadio>
            <br />
            <small>( Download File from URL and export [default] )</small>
          </div>
        </div>
        <div className="col-4">
          <div className="form-check">
            <CustomRadio label="Export Data into CSV" isRadio={true}>
              <input
                name="generateCSV"
                type="radio"
                className="form-check-input"
                checked={generateCSV === 'GENERATE_CSV'}
                value="GENERATE_CSV"
                onChange={handleRadioChange}
              />
            </CustomRadio>
            <br />
            <small>( Create CSV from Response.)</small>
          </div>
        </div>
        <div className="col-4">
          <div className="form-check">
            <CustomRadio label="Download File from URL" isRadio={true}>
              <input
                name="generateCSV"
                type="radio"
                className="form-check-input"
                checked={generateCSV === 'DOWNLOAD_FILE_URL'}
                value="DOWNLOAD_FILE_URL"
                onChange={handleRadioChange}
              />
            </CustomRadio>
            <br />
            <small>( Download File from URL and export )</small>
          </div>
        </div>
      </div>
      {generateCSV === 'GENERATE_CSV' && (
        <div className="row">
          <div className="col-6 mt-2">
            <div className="form-group">
              <CustomInputWithIcon icon="text">
                <input
                  name="exportItemsPath"
                  onChange={handleAuthData}
                  value={exportItemsPath}
                  className="form-control form-control-sm"
                  placeholder="Response Data Items Path (Optional)"
                />
              </CustomInputWithIcon>
            </div>
          </div>
          <div className="col-6 mt-2">
            <div className="form-group">
              <CustomInputWithIcon icon="text">
                <input
                  name="exportFileName"
                  onChange={handleAuthData}
                  value={exportFileName}
                  className="form-control form-control-sm"
                  placeholder="File Name"
                />
              </CustomInputWithIcon>
            </div>
          </div>
        </div>
      )}
      {generateCSV === 'DOWNLOAD_FILE_URL' && (
        <div className="row">
          <div className="col-6 mt-2">
            <div className="form-group">
              <CustomInputWithIcon icon="text">
                <input
                  name="exportItemsPath"
                  onChange={handleAuthData}
                  value={exportItemsPath}
                  className="form-control form-control-sm"
                  placeholder="Response Data File Path"
                />
              </CustomInputWithIcon>
            </div>
          </div>
        </div>
      )}
    </CardForMapping>
  );
};

export default ExportResponseFile;
